import { useLoading } from "../context/LoadingContext";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  FaChevronDown,
  FaChevronUp,
  FaSave,
  FaCalendarAlt,
  FaPlus,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import "../css/Producao.css";
import { useProducao } from "../context/ProducaoContext";
import { useUser } from "../context/UserContext";
import SelectBoxResponsavelPesquisa from "./SelectBoxResponsavelPesquisa";
import SelectBoxResponsavelCadastro from "./SelectBoxResponsavelCadastro";
import SelectEtiquetas from "../components/SelectEtiquetas";
import BackButton from "../components/BackButton";

registerLocale("pt-BR", ptBR);

const Producao = () => {
  const { buscarProducoes, registrarProducao, today } = useProducao();
  const { user, userDecoded } = useUser();

  const _decoded = userDecoded();
  const _isDev = _decoded?.perfis?.includes("DESENVOLVEDOR");
  const _defaultResponsavel = !_isDev && _decoded?.userId ? _decoded.userId : "";

  const [selectedMonth, setSelectedMonth] = useState(today.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(today.getFullYear());
  const [responsavelSelecionadoPesquisa, setResponsavelSelecionadoPesquisa] =
    useState(_defaultResponsavel);
  const [responsavelSelecionadoCadastro, setResponsavelSelecionadoCadastro] =
    useState(_defaultResponsavel);
  const [producoes, setProducoes] = useState([]);
  const { setIsLoading } = useLoading();
  const [expandedId, setExpandedId] = useState(null);
  const [novaProducao, setNovaProducao] = useState(false);
  const { id } = useParams();
  const [formData, setFormData] = useState({
    nome: "",
    data: today.toISOString().split("T")[0],
    responsavel: "",
    itens: [],
  });
  const [selectedEtiqueta, setSelectedEtiqueta] = useState(null);

  const reloadProducao = async (
    selectedMonth,
    selectedYear,
    id,
    responsavelSelecionadoPesquisa
  ) => {
    const toastId = toast.loading("Buscando produções...");
    setIsLoading(true);
    try {
      const dados = await buscarProducoes(
        selectedMonth,
        selectedYear,
        id,
        responsavelSelecionadoPesquisa
      );
      setProducoes(dados);
      toast.update(toastId, {
        render: "Busca concluída!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Erro ao carregar produções.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    reloadProducao(
      selectedMonth,
      selectedYear,
      id,
      responsavelSelecionadoPesquisa
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleItemQuantidadeChange = (index, event) => {
    const { value } = event.target;
    const newItens = [...formData.itens];
    newItens[index] = {
      ...newItens[index],
      quantidade: parseInt(value) || 0,
    };
    setFormData((prev) => ({
      ...prev,
      itens: newItens,
    }));
  };

  const addItem = (selectedOption) => {
    if (selectedOption) {
      const newItem = {
        itemNome: selectedOption.value,
        quantidade: 1,
      };
      setFormData((prev) => ({
        ...prev,
        itens: [...prev.itens, newItem],
      }));
      setSelectedEtiqueta(null);
    }
  };

  const removeItem = (index) => {
    const newItens = formData.itens.filter((_, i) => i !== index);
    setFormData((prev) => ({
      ...prev,
      itens: newItens,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const toastId = toast.loading("Salvando produção...");
    setIsLoading(true);

    try {
      await registrarProducao({
        data: formData.data,
        nome: formData.nome,
        idResponsavel: responsavelSelecionadoCadastro,
        restauranteId: id,
        itens: formData.itens,
      });

      const dados = await buscarProducoes(
        selectedMonth,
        selectedYear,
        id,
        responsavelSelecionadoCadastro
      );
      setProducoes(dados);
      setResponsavelSelecionadoPesquisa(responsavelSelecionadoCadastro);
      setNovaProducao(false);
      setFormData({
        data: today.toISOString().split("T")[0],
        responsavel: "",
        itens: [],
        nome: "",
      });
      toast.update(toastId, {
        render: "Produção salva com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Erro ao salvar produção",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleMonthYearChange = (date) => {
    setSelectedMonth(date.getMonth() + 1);
    setSelectedYear(date.getFullYear());
  };

  const formatarData = (dataString) => {
    return new Date(dataString).toLocaleDateString("pt-BR");
  };
  const perfisComAcesso = ["DESENVOLVEDOR", "ADMIN", "GERENTE"];
  const decoded = userDecoded();
  const temAcesso = decoded?.perfis?.some((perfil) =>
    perfisComAcesso.includes(perfil)
  );

  return (
    <div className="relatorio-container">
      <BackButton inline />
      <h1>Listagem de Produções</h1>

      <div className="filtro-container">
        <div className="periodo-selecionado">
            <span>Período:</span>
        </div>
        <div className="filtro-data-group">
          <div className="filtro-data">
            <FaCalendarAlt className="filtro-icon" />
            <DatePicker
              selected={new Date(selectedYear, selectedMonth - 1, 1)}
              onChange={handleMonthYearChange}
              locale="pt-BR"
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="date-picker-input"
              placeholderText="Selecione mês/ano"
            />
          </div>
        </div>

        <div>
          <SelectBoxResponsavelPesquisa
            value={responsavelSelecionadoPesquisa}
            onChange={setResponsavelSelecionadoPesquisa}
          />
        </div>
        <div className="botoes-superiores">
          <button
            className="btn-adicionar"
            onClick={() =>
              reloadProducao(
                selectedMonth,
                selectedYear,
                id,
                responsavelSelecionadoPesquisa
              )
            }
            disabled={false}
          >
            Buscar
          </button>
        </div>
      </div>
      {temAcesso && (
        <div className="botoes-superiores">
          <button
            className="btn-novo"
            onClick={() => setNovaProducao(!novaProducao)}
            disabled={false}
          >
            {novaProducao ? "Cancelar" : "Nova Produção"}
          </button>
        </div>
      )}
      {temAcesso && novaProducao && (
        <form className="form-novo" onSubmit={handleSubmit}>
          <h2>Nova Produção</h2>

          <div className="form-group">
            <label>
              Nome:
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                required
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Data:
              <input
                type="date"
                name="data"
                value={formData.data}
                onChange={handleInputChange}
                required
              />
            </label>
            <div>
              <SelectBoxResponsavelCadastro
                value={responsavelSelecionadoCadastro}
                onChange={setResponsavelSelecionadoCadastro}
              />
            </div>
          </div>

          <div className="itens-producao-container">
            <h3>Itens de Produção</h3>
            <div className="add-item-producao">
              <SelectEtiquetas
                value={selectedEtiqueta}
                onChange={(selectedOption) => {
                  setSelectedEtiqueta(selectedOption);
                  addItem(selectedOption);
                }}
              />
            </div>
            <ul className="lista-itens-producao">
              {formData.itens.map((item, index) => (
                <li key={index} className="item-producao">
                  <span className="item-producao-nome">{item.itemNome}</span>
                  <div className="item-producao-controls">
                    <input
                      type="number"
                      name="quantidade"
                      value={item.quantidade}
                      onChange={(e) => handleItemQuantidadeChange(index, e)}
                      required
                      min="1"
                      className="item-producao-quantidade"
                    />
                    <button
                      type="button"
                      className="btn-remover-item"
                      onClick={() => removeItem(index)}
                    >
                      &times;
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <button type="submit" className="btn-salvar" disabled={false}>
            <FaSave /> {false ? "Salvando..." : "Salvar"}
          </button>
        </form>
      )}

      {false ? (
        <div className="loading-spinner">Carregando...</div>
      ) : (
        <div className="lista-producoes">
          {producoes.length > 0 ? (
            producoes.map((producao) => (
              <div
                key={producao.id}
                className={`producao-card ${
                  expandedId === producao.id ? "expanded" : ""
                }`}
              >
                <div
                  className="card-header"
                  onClick={() => toggleExpand(producao.id)}
                >
                  <span>Produção de {formatarData(producao.data)}</span>
                  {expandedId === producao.id ? (
                    <FaChevronUp />
                  ) : (
                    <FaChevronDown />
                  )}
                </div>
                {expandedId === producao.id && (
                  <div className="card-detalhes">
                    <h4 className="itens-titulo">Itens Produzidos</h4>
                    <div className="itens-lista">
                      {producao.itens.map((item, index) => (
                        <div key={index} className="item-producao">
                          <span className="item-nome">{item.itemNome}</span>
                          <span className="item-quantidade">
                            {item.quantidade} unidades
                          </span>
                        </div>
                      ))}
                    </div>

                    <div className="detalhes-info">
                      <div className="detalhes-linha">
                        <span className="detalhes-label">Responsável:</span>
                        <span>{producao.responsavelNome || "Nenhum"}</span>
                      </div>
                      <div className="detalhes-linha">
                        <span className="detalhes-label">Restaurante:</span>
                        <span>{producao.restauranteNome || "Nenhum"}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="sem-resultados">
              Nenhuma produção encontrada para o período selecionado
            </p>
          )}
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default Producao;
